.container {
  height: calc(100vh - 22%);
  padding: 9rem 1.2rem;
  text-align: center;
}

.heading {
  margin-bottom: 15px;
}

.link {
  color: var(--accent-color);
}

.link:hover {
  text-decoration: underline;
}
